module.exports = __webpack_public_path__ + "img/icon-notification-off.bac29201.svg";